module.exports = __webpack_public_path__ + "static/media/investbanner@2x.4e126494.png";